export default {
	mounted (el, binding) {
		let animateObj = binding.value;
		let animteCls = ` animated ${animateObj.showName}`;
		el.className += animteCls;
		el.style.animationDelay = animateObj.delay + "ms";
		el.style.animationDuration = animateObj.duration + "ms";
	},
	beforeUnmount (el, binding) {
		let animateObj = binding.value;
		let animteCls = ` animated ${animateObj.hideName}`;
		el.className += animteCls;
		el.style.animationDelay = animateObj.delay + "ms";
		el.style.animationDuration = animateObj.duration + "ms";
	},
};
